import React, { FC } from 'react';
import cls from './MonthModeStage.module.css';
import classNames from 'classnames';
import moment from 'moment/moment';
import { StageItem } from '../../../../../../UI/StageItem/StageItem';

export const MonthItem = ({ month, isPlanFact, stage }) => {
    const stageDate = moment(stage.planned.start_date).format('DD.MM.YYYY');

    const nowDate = moment().format('DD.MM.YYYY');

    const isRenderDays =
        month.date === moment(stage.planned.start_date).format('MM.YYYY') ||
        month.date === moment().format('MM.YYYY');

    return (
        <div
            className={classNames(cls.month, { [cls.factWrapper]: isPlanFact })}
            style={{ width: 7 * month.dayInMonth }}
        >
            {isRenderDays &&
                month.days.map((day, i) => (
                    <div
                        className={classNames(cls.day, {
                            [cls.factWrapper]: isPlanFact,
                            [cls.nowDate]: day.date === nowDate,
                        })}
                        key={day.date + (i + 100) + stage.id}
                    >
                        {day.date === stageDate && (
                            <StageItem isPlanFact={isPlanFact} stage={stage} />
                        )}
                    </div>
                ))}
        </div>
    );
};
